import { render, staticRenderFns } from "./SignatureForm.vue?vue&type=template&id=1b134f6a&scoped=true"
import script from "./SignatureForm.vue?vue&type=script&lang=js"
export * from "./SignatureForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b134f6a",
  null
  
)

export default component.exports